// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/d6015543/" + chunkId + "." + __webpack_require__.h() + ".vd6015543.js";
};